/**
 * 존(다신안가/아쉬워/좋아/인생맛집) 안에서 순위 → 점수.
 *
 * 서버의 ReviewScoreService와 같은 식이다. 랭킹 화면에서 끌어 옮기는 동안
 * 보여주는 점수가 저장 후 값과 달라지면 안 되므로, 반드시 같은 규칙이어야 한다.
 * 한쪽을 바꾸면 다른 쪽도 바꿀 것.
 */

/** 존 경계. 길이 = ZONE_COUNT + 1. zone i = [BOUNDS[i], BOUNDS[i+1]] */
const ZONE_BOUNDS = [1.0, 3.0, 5.0, 8.0, 10.0]

export const ZONE_COUNT = 4

/** 존 내 점수 펼침 완충계수. 클수록 데이터가 적을 때 중앙값 가까이 모인다 */
const ZONE_SPREAD_DAMPING = 2.0

const round2 = (v: number) => Math.round(v * 100) / 100

/**
 * 존 내 순위(index, 0 = 최고) → 점수.
 *
 * 최상위가 아닌 존은 상한을 0.01 낮춘다. 그래야 최고점이 다음 존의 시작값과
 * 겹치지 않는다(7.99는 '좋아', 8.00부터 '인생맛집').
 */
export function zoneScore(index: number, count: number, zone: number): number {
  const z = Math.max(0, Math.min(ZONE_COUNT - 1, zone))
  const a = ZONE_BOUNDS[z]
  const b = z < ZONE_COUNT - 1 ? round2(ZONE_BOUNDS[z + 1] - 0.01) : ZONE_BOUNDS[z + 1]

  const mid = (a + b) / 2
  if (count <= 1) return round2(mid)

  const half = (b - a) / 2
  const spread = (count - 1) / (count - 1 + ZONE_SPREAD_DAMPING)
  const pos = (2 * (count - 1 - index)) / (count - 1) - 1 // -1(꼴찌) ~ +1(1등)

  return round2(Math.max(0, Math.min(10, mid + pos * half * spread)))
}
